
const { getModulesKeyCustomized } = require('~/webpack/require-context')
import VueComponents from '~/vuestrap/components/registration'

const requireContext = require.context(`~/components/`, true, /.*\.vue$/)
const components = getModulesKeyCustomized(requireContext, key => key.replace(/(\/index)?\.vue$/, '').replace(/^.*\//g, ''))
VueComponents(components, {namePrefix: 'Passport'})
